import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import './css/variables.css';
import './css/home.css';
import './css/about.css'; 
import './css/agentic.css';
import './css/arvr.css';
import './css/meta.css';
import './css/services.css';
import './css/portfolio.css';
import './css/technologies.css';
import './css/process.css';
import './css/contact.css';
import './css/legal.css';
import './css/sections.css';
import './App.css';

import Home from './pages/Home';
import About from './pages/About';
import AgenticAI from './pages/AgenticAI';
import ARVR from './pages/ARVR';
import Meta from './pages/Meta';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Technologies from './pages/Technologies';
import Process from './pages/Process';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Cookies from './pages/Cookies';

function AppRoutes() {
  const location = useLocation();

  return (
    <Routes location={location} key={location.pathname}>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/agentic-ai" element={<AgenticAI />} />
      <Route path="/arvr" element={<ARVR />} />
      <Route path="/meta" element={<Meta />} />
      <Route path="/services" element={<Services />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/technologies" element={<Technologies />} />
      <Route path="/process" element={<Process />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/cookies" element={<Cookies />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <AppRoutes />
      <Footer />
    </BrowserRouter>
  );
}

export default App;